import { EventEmitter, Injectable } from '@angular/core';
import { ApiManagerService } from './api-manager.api.service';
import { GET_FAQ_CMS, GET_VIDEO_TUTORIALS } from '../../lib/contsants';

@Injectable({
  providedIn: 'root',
})
export class CmsApiService {
  mystatusChanged: EventEmitter<any> = new EventEmitter();

  constructor(protected apiManager: ApiManagerService) {}

  protected get getCmsApi(): string {
    return this.apiManager.getCMSApiUrl();
  }

  getFaqCMSUrl(): string {
    return `${this.getCmsApi}/${GET_FAQ_CMS}`;
  }

  getVideoTutorialCMSUrl(): string {
    return `${this.getCmsApi}/${GET_VIDEO_TUTORIALS}`;
  }
}
